module.exports = __webpack_public_path__ + "img/hi.786e302a.png";